import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalContainer } from 'src/components/core';
import { LoyaltyPassQRCode } from 'src/components/loyalty-pass/loyalty-pass-qr-code';
import { ModalComponentProps, withModalControlsHook } from 'src/components/modals/with-modal-controls-hook';

export type LoyaltyPassModalData = {
  url: string | null;
  loading?: boolean;
  variant: 'bank-account' | 'loyalty';
};

const LoyaltyPassModal = ({
  onClose,
  containerProps,
  data,
}: ModalComponentProps<LoyaltyPassModalData>): JSX.Element => {
  const { url, loading = false, variant } = data;
  const width = variant === 'loyalty' ? '470px' : '438px';

  return (
    <ModalWrapper
      open
      role='dialog'
      aria-modal='true'
      aria-labelledby='loyalty-pass-title'
      aria-describedby='loyalty-pass-instructions'
    >
      <ModalContainer width={width} p='32px' {...containerProps}>
        <LoyaltyPassQRCode url={url ?? null} loading={loading} onClose={onClose} variant={variant} />
      </ModalContainer>
    </ModalWrapper>
  );
};

const [LoyaltyPassController, useLoyaltyPassModal] = withModalControlsHook<LoyaltyPassModalData>(LoyaltyPassModal);

export { useLoyaltyPassModal, LoyaltyPassController };
